import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse } from '../responses/Action';
import { BalancaService } from './Service';

/**
 * 
 * @param {Objeto completo contendo lista de balancas} balancaObject 
 */
export const getBalancaResponse = balancaObject => ({
    type: ActionType.GET_BALANCA_RESPONSE,
    balancaObject
});


export function getBalancaAction() {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let balancaObject = await BalancaService.getBalancas()
            dispatch(getBalancaResponse(balancaObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function getLeituraAction() {
    return async function (dispatch) {      
        try {
            let balancaObject = await BalancaService.getLeitura()
            dispatch(getBalancaResponse(balancaObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}